import type { StateEnum } from "@lending/types";

/** States where an applicant cannot continue the application flow. */
const TERMINAL_APPLICATION_STATES: ReadonlySet<StateEnum> = new Set<StateEnum>([
  "completed",
  "canceled",
  "expired",
  "decisioning_rejected",
  "decisioning_failed",
  "los_processing_failed",
  "membership_share_failed",
]);

export function isInProgressApplicationState(state: StateEnum): boolean {
  return !TERMINAL_APPLICATION_STATES.has(state);
}
